import { render, staticRenderFns } from "./Alternate.vue?vue&type=template&id=4efb02a7&scoped=true"
import script from "./Alternate.vue?vue&type=script&lang=ts"
export * from "./Alternate.vue?vue&type=script&lang=ts"
import style0 from "./Alternate.vue?vue&type=style&index=0&id=4efb02a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efb02a7",
  null
  
)

export default component.exports